import { useEffect, useState } from "react";

// Flags that this browser holds an SSO session. The session itself is the
// backend's HttpOnly admin-auth-token cookie; this value is only ever "1" and is
// never a credential.
const SSO_SESSION_KEY = "ssoSession";

let _active = localStorage.getItem(SSO_SESSION_KEY) === "1";
const _listeners = new Set<(active: boolean) => void>();

function _notify(active: boolean) {
  _active = active;
  _listeners.forEach((fn) => fn(active));
}

export function useSsoSession(): boolean {
  const [active, setActive] = useState(() => _active);

  useEffect(() => {
    _listeners.add(setActive);

    // Another tab logged in or out: reload so this tab picks up the new session.
    const handleStorage = (e: StorageEvent) => {
      if ((e.key === SSO_SESSION_KEY || e.key === "refreshToken") && e.newValue !== e.oldValue) {
        window.location.reload();
      }
    };
    window.addEventListener("storage", handleStorage);

    return () => {
      _listeners.delete(setActive);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return active;
}

export function setSsoSession(): void {
  localStorage.setItem(SSO_SESSION_KEY, "1");
  _notify(true);
}

export function clearSsoSession(): void {
  localStorage.removeItem(SSO_SESSION_KEY);
  localStorage.removeItem("refreshToken");
  _notify(false);
}
